import {defineMessages} from 'react-intl';

export default defineMessages({
	colorName: {
		id: 'pdp.colorSelection.colorName',
		defaultMessage: 'Colour:',
	}
});
